"use client";

import { useEffect } from "react";
import i18n from "@/i18n";
import { useAppStore } from "@/stores/useAppStore";
import { getStoredAppLanguage, normalizeLanguageCode } from "@/lib/language";

export default function TenantLanguageBootstrap({
  initialLanguage,
  initialTimezone,
}: {
  initialLanguage?: string | null;
  initialTimezone?: string | null;
}) {
  const language = useAppStore((state) => state.language);
  const applyLanguageFallback = useAppStore((state) => state.applyLanguageFallback);

  useEffect(() => {
    const userChosenLanguage = getStoredAppLanguage();
    if (userChosenLanguage) {
      return;
    }

    const tenantLanguage = normalizeLanguageCode(initialLanguage);
    document.cookie = `tenant_default_language=${encodeURIComponent(tenantLanguage)}; path=/`;

    if (language !== tenantLanguage) {
      applyLanguageFallback(tenantLanguage);
    } else {
      i18n.changeLanguage(tenantLanguage);
    }
  }, [applyLanguageFallback, initialLanguage, language]);

  useEffect(() => {
    if (!initialTimezone) return;
    document.cookie = `tenant_default_timezone=${encodeURIComponent(initialTimezone)}; path=/`;
  }, [initialTimezone]);

  return null;
}
